// Picklist Group Name
export const PICKLIST_GROUP_NAME = {
  Gender: "People_Gender",
  User_Types: "User_Types",
  Web_Application_Role: "Web_Application_Role",
  Organization_Departments: "Organization_Departments",
  Salutation_Type: "Salutation_Type",
  Case_Review_Type: "Case_(Review)_Type",
  Case_Priority: "Case_Priority",
  Address_Type: "Address_Type",
  Case_Stages: "Stages_of_Case",
  Injury_Type: "Injury_Type",
  SeverityOf_Injury: "Severity_of_Injury",
  Nature_of_Injury: "Nature_of_Injury",
  Appointment_Type: "Appointment_Type",
  Appointment_Category: "Appointment_Category",
  Appointment_Status: "Appointment_Status",
  Conduct_Medical_Exam: "Conduct_Medical_Exam",
  Interpreter_Language: "Interpreter_Language",
  Document_Category: "Document_Category",
  Stakeholder_Types: "Stakeholder_Types",
  Notes_Category: "Notes_Category",
  Stages_of_Case: "Stages_of_Case",
  Location_SplInstructions: "Location_SplInstructions",
  Region_List: "Region_List",
};

export const STAKEHOLDER_LIST_CODE = {
  QME_DOCTOR: "CL",
  PRACTICE_MANAGEMENT_COMPANY: "CL",
  EMPLOYER: "EP",
  ATTORNEY: "AT",
  INSURANCE: "IN",
  VENDOR: "VD",
  PAITENT: "IP",
  SERVICE_PROVIDER: "SP",
  APPLICANT_ATTORNEY: "AA",
  DEFENCE_ATTORNEY: "DA",
};

export const SERVICE_PROVIDER_DEFAULT = {
  SERVICE_PROVIDER_ACUTRANS: "AcuTrans Solutions LLP",
};

export const WEB_ROLE = {
  System_Admin: "System Admin",
  App_Admin: "App Admin",
  Case_Manager: "Case Coordinator",
  QME_Doctor: "QME Doctor (PMC Staff)",
  QME_DoctorPMC: "QME Doctor (PMC Staff)",
  IndependentQMEDoctor: "Independent QME Doctor",
  Transcriber: "Transcriber",
  Injured_Worker: "Injured Worker",
  Claims_Administrator: "Claims Administrator",
  Historian: "Historian",
  Billing_Specialist: "Billing Specialist",
  Payment_Collector: "Payment Collector",
  IT_Support: "IT Support",
  Auditor: "Auditor",
  Supervisor: "Supervisor",
  Scheduler: "Scheduler",
  Compliance_Officer: "Compliance Officer",
  Editor: "Editor",
  Employer: "Employer",
  Applicant_Attorney: "Applicant Attorney",
  Defense_Attorney: "Défense Attorney",
  Service_Provider: "Service Provider",
  Medical_Assistant: "Medical Assistant",
  Record_Reviewer: "Record Reviewer",
  Practice_Manager: "Practice Manager (PMC Staff)",
};

export const STAKEHOLDER_TYPE = {
  QME_Doctor: "QME Doctor",
  PMC: "Practice Management Company (PMC)",
  Attorney: "Attorney",
  Insurance: "Insurance (Claims)",
  Employer: "Employer",
  Applicant_Attorney: "Applicant Attorney",
  Défense_Attorney: "Défense Attorney",
  Patient: "Patient",
  Service_Provider: "Service Provider",
  Vendor: "Vendor (Interpreter Services)",
};

export const QME_APPOINTMENT_STATUS = {
  SCHEDULED: "Scheduled",
  RESCHEDULED: "Re-Scheduled",
  CANCELLED: "Cancelled",
  PATIENT_NO_SHOW: "Patient No-Show",
  QME_NO_SHOW: "QME No-Show",
  INTERPRETER_NO_SHOW: "Interpreter No Show",
  COMPLETED: "Completed",
  QME_REQUESTED_RESCHEDULE: "QME Doctor Requested Reschedule",
  QME_REQUESTED_CANCELLATION: "QME Doctor Requested Cancellation",
  PATIENT_CHECKED_IN: "Patient Checked In",
  PATIENT_DENIED_APPOINTMENT: "Patient Denied Appointment",
  PATIENT_ACCEPT_APPOINTMENT: "Patient Accepted Appointment",
  CANCELLED_PATIENT_NO_SHOW: "Cancelled-Patient No Show",
  CANCELLED_INTERPRETER_NO_SHOW: "Cancelled Interpreter No Show",
  CANCELLED_QME_NO_SHOW: "Cancelled- QME No Show",
};

export const QME_APPOINTMENT_SCHEDULE_CATEGORY = {
  Upcoming: "Upcoming",
  Past: "Past",
  Today: "Today",
};

export const NOTIFICATIONS_PRIORITY = {
  Critical: "Critical",
  Medium: "Medium",
  Low: "Low",
};

export const SHARE_RECORDS_STATUS = {
  REVOKED: "Revoked",
  ACTIVE: "Active",
  EXPIRED: "Expired",
};

export const CASE_STAGE_STATUS = {
  NEW: "New",
  REGISTERED: "Registered",
  ONHOLD: "OnHold",
  RESUME: "Resume",
  CLOSED: "Case Closed",

  UNARCHIVED: "Unarchived",
  ARCHIVED: "Archived",
  CANCELLED: "Cancelled",

  SCHEDULE: "Scheduled",
  DOCUMENTPREPARATION: "Document Preparation",
  SCHEDULING: "Scheduling",
  EVALUATION: "Evaluation",
  DRAFTINGREPORT: "Drafting Report",
  REPORTRIVIEW: "Report Review",
  REPORTFINALIZE: "Report Finalized",
  BILLING: "Billing",
  PAYMENTPENDING: "Payment Pending",
  PAYMENTCOMPLETE: "Payment Completed",
  COMPLIANCEREVIEW: "Compliance Review",
  DESPOSITION: "Deposition",

  NewONHOLD: "New (On Hold)",
  REGISTEREDONHOLD: "Registered (On Hold)",
  PAYMENTPENDINGONHOLD: "Payment Pending (On Hold)",
  SCHEDULEONHOLD: "Scheduled (On Hold)",
  DOCUMENTPREPARATIONONHOLD: "Document Preparation (On Hold)",
  SCHEDULINGONHOLD: "Scheduling (On Hold)",
  EVALUATIONONHOLD: "Evaluation (On Hold)",
  DRAFTINGREPORTONHOLD: "Drafting Report (On Hold)",
  REPORTRIVIEWONHOLD: "Report Review (On Hold)",
  REPORTFINALIZEONHOLD: "Report Finalized (On Hold)",
  BILLINGONHOLD: "Billing (On Hold)",
  PAYMENTCOMPLETEONHOLD: "Payment Completed (On Hold)",
  COMPLIANCEREVIEWONHOLD: "Compliance Review (On Hold)",
  DESPOSITIONHOLD: "Deposition (On Hold)",
};

export const FEATURE_ACCESS_STATUS = {
  CREATE_CASE: "Create Case",
  EDIT_CASE: "Edit Case",
  VIEW_CASE: "View Case",
  ARCHIVE_CASE: "Archive Case",
  UNARCHIVE_CASE: "Un-Archive Case",
  SEARCH_CASE: "Search Case",
  DEPOSITIONONHOLD: "Deposition",
};

export const PARTY_TYPES = {
  CLIENT: "Client",
  APPLICANT: "Applicant",
  DEFENCE: "Defence",
  INSURANCE: "Insurance",
  EMPLOYER: "Employer",
  Applicant_Attorney: "Applicant Attorney",
  Défense_Attorney: "Défense Attorney",
  Service_Provider: "Service Provider",
};

export const FILE_SIZE = {
  ONE_GB: 1073741824,
  TWO_GB: 2147483648,
};

export const HISTORY_REPORT_STATUS = {
  NOT_SCHEDULED: "Not Scheduled",
  SCHEDULED: "Scheduled",
  PENDING: "Pending",
  AWAITING: "Awaiting Response",
  DRAFT: "Draft",
  EXCEPTION: "Exception",
  COMPLETED: "Completed",
  Completed_Delayed: "Completed [Delayed]",
  OVERDUE: "Overdue",
  CANCELLED: "Cancelled (Appointment)",
};

export const HISTORIAN_SUMMARY_CODES = {
  OVERDUE_NEARDUE: "ODND", // Overdue - NearDue
  OVERDUE_TODAY: "ODTD", // Overdue - Today
  OVERDUE: "OVDU", // Overdue
  DRAFT_HISTORIES: "DFHS", // Draft Histories
  SCHEDULED_TODAY: "SDTD", // Scheduled Histories - Today
  SCHEDULED_THIS_WEEK: "SDTW", // Scheduled Histories - This Week
  SCHEDULED_THIS_MONTH: "SDTM", // Scheduled Histories - This Month
  TOTAL_PENDING: "THPD", // Total Histories - Pending
  TOTAL_COMPLETED: "THCD", // Total Histories - Completed
  APPOINTMENT_CANCELLED: "CNAP",
  NOT_SCHEDULED: "NTSD", // Not Scheduled
  NOT_SCHEDULED_OVERDUE: "NTOD",
  AWAITING_RESPONSE: "AWRE", // Awaiting Response
  ALL_REPORTS: "ALLH", // All Reports
};

export const EDITOR_REPORT_STATUS = {
  EDITING_PENDING: "Editing Pending",
  EDITING_NOT_INITIATED: "Editing Not Initiated",
  EDITING_IN_PROGRESS: "Editing In-Progress",
  PENDING_DOCTOR_APPROVAL: "Pending Doctor Approval",
  APPROVED_BY_DOCTOR: "Approved By Doctor",
  SENT_FOR_REWORK: "Sent For Rework",
  DRAFT_PENDING_DOCTOR_APPROVAL: "PendingDoctorApproval",
  COMPLETED: "Completed",
  OVERDUE: "Overdue",
  EXCEPTION: "Exception",
};

export const TRANSCRIPTION_REPORT_STATUS = {
  TRANSCRIPTION_PENDING: "Transcription Pending",
  TRANSCRIPTION_NOT_INITIATED: "Transcription Not Initiated",
  TRANSCRIPTION_IN_PROGRESS: "Transcription In Progress",
  TRANSCRIPTION_COMPLETED: "Transcription Completed",
  EXCEPTION: "Exception",
  DICTATION_PENDING: "Dictation Pending",
};

export const EDITOR_SUMMARY_CODES = {
  OVERDUE_NEARDUE: "ODND",
  OVERDUE_TODAY: "ODTD",
  OVERDUE: "OVDU",
  ALL_REPORTS: "ALER",
  EDITING_NOT_INITIATED: "TSPD",
  EDITING_OVERDUE: "TSOD",
  QME_SENT: "QAST",
  QME_APPROVED: "QAAP",
  QME_REWORK: "QARW",
  QME_IN_PROGRESS: "QRIP",
  QME_COMPLETED: "QRCP",
  DWC_EXTENSION: "DWCE",
  EXCEPTION: "EXCP",
};

export const TRANSCRIBER_SUMMARY_CODES = {
  OVERDUE_NEARDUE: "ODND",
  OVERDUE_TODAY: "ODTD",
  OVERDUE: "OVDU",
  ALL_REPORTS: "ALLT",
  EDITING_NOT_INITIATED: "TRPN",
  TRANSCRIPTION_IN_PROGRESS: "TRIP",
  TRANSCRIPTION_COMPLETED: "TRCD",
  TRANSCRIPTION_EXCEPTION: "TREP",
  EXCEPTION: "EXCP",
};

export const RECORD_REVIEWER_SUMMARY_CODES = {
  OVERDUE_NEARDUE: "ODND",
  OVERDUE_TODAY: "ODTD",
  OVERDUE: "OVDU",
  DRAFT_REVIEWS: "DFRV",
  TOTAL_REVIEWS_PENDING: "TRNI",
  TOTAL_INREVIEWS: "TRPD",
  TOTAL_REVIEWS_COMPLETED: "TRCD",
  APPOINTMENT_CANCELLED: "CNAP",
  NOT_INITIATED: "TRNI",
  NOT_SCHEDULED_OVERDUE: "TROD",
  AWAITING_RESPONSE: "AWRE",
  ALL_RORS: "ALLR",
};

export const ROR_STATUS = {
  NOT_INITIATED: "Not Initiated",
  IN_REVIEW: "In Review",
  DRAFT_REVIEW: "Draft Review",
  REVIEW_COMPLETED: "Review Completed",
  Review_Completed_Delayed: "Review Completed [Delayed]",
  EXCEPTION: "Exception",
  Cancelled_Appointment: "Cancelled (Appointment)",
  Pending_Review: "Pending Review",
};

export const DOCTOR_TODO_CODES = {
  OVERDUE_NEARDUE: "ODND",
  OVERDUE_TODAY: "ODTD",
  OVERDUE: "OVDU",
  ALL_REPORTS: "ALLR",
  TOTAL_PENDING_DICTATION: "PDDT",
  PENDING_TRANSCRIPTION: "PDTS",
  QME_SENT: "QAST",
  QME_APPROVED: "QAAP",
  QME_REWORK: "QARW",
  QME_IN_PROGRESS: "QRIP",
  QME_COMPLETED: "QRCP",
  DWC_EXTENSION: "DWCE",
  EXCEPTION: "EXCP",
};

export const QME_DOCTOR_DOCUMENT_TYPES = {
  SUPPLEMENTAL_REPORT: "Supplemental Report",
  INITIAL_EVALUATION_REPORT: "Initial Evaluation Report",
  RE_EVALUATION_REPORT: "Re-Evaluation Report",
  SIBTF_REPORT: "SIBTF Report",
  QME_FINAL_REPORT: "QME Final Report",
  QME_DRAFT_REPORT: "QME Draft Report",
};

export const RATE_TYPE = {
  FLAT: "Fixed",
  PER_PAGE: "PER_PAGE",
  PER_LINE: "PER_LINE",
};

export const INVOICE_STATUS = {
  READY_TO_BILL: "Ready To Bill",
  READY_TO_RE_BILL: "Ready To Re-Bill",
  READY_TO_BILL_AMENDED: "Ready To Bill (Amended)",
  READY_TO_RE_BILL_AMENDED: "Ready To Re-Bill (Amended)",
  GENERATED: "Generated",
  EXCEPTION: "Exception - Adjustment/Incorrect Data",
  EXCEPTION_NO_BILLING_CONFIG: "Exception - No Billing Config",
  EXCEPTION_INVALID_BILLING_CONFIG: "Exception - Invalid Billing Config",
  EXCEPTION_MULTIPLE_BILLING_CONFIG:
    "Exception - Multiple Billing Configuration Setup",
  EXCEPTION_MISSING_PAGE_COUNT: "Exception - Missing Page Count",
  EXCEPTION_MISSING_LINE_COUNT: "Exception - Missing Line Count",
  ON_HOLD: "Exception - On Hold",
  CANCELLED: "Cancelled",
  INVOICED: "Invoiced",
  PENDING: "Pending",
  INVOICE_GENERATED: "Invoice Generated",
  INVOICE_AMENDED: "Invoice Amended",
  INVOICE_CANCELLED: "Invoice Cancelled",
};

export const INVOICE_REPORTS_CODES = {
  GENERATE: "Generated",
  AMENDED: "Amended",
  CANCELED: "Cancelled",
};

export const MANAGE_INVOICE_CODES = {
  ALL: "All",
  PENDING_ALL: "PendingAll",
  READY_TO_BILL: "PendingReadytoBill",
  READY_TO_RE_BILL: "PendingReadytoReBill",
  EXCEPTION: "Exception",
  GENERATED: "InvoiceGenerated",
  CANCELED: "Cancelled",
};

export const PAGE_SLAB_MAX_LIMIT = 10000000;
